export const queryKeys = {
  users: 'users',
  investments: 'investments',
};
